import { useQuery } from '@tanstack/react-query'
import { configApi } from '../lib/api'
import { useCommitteeScope } from './useCommitteeScope'
import type { AvailableState } from '../types/config'

/**
 * The single source for locality (state) pickers. Consumed by the Lobby Day "Sync from
 * LegiScan" dropdown today; the analytics map and contact/list filters are its intended
 * later consumers. Returns all 50 states + DC now; once per-instance data-access config
 * lands, GET /api/config/available-states narrows and every picker narrows with it.
 * See vault note "Customer Locality Scoping — State & District Data Access".
 *
 * The active committee scope folds into the key (not the request) so a switch of the
 * parked acting committee forces a refetch -- the axios interceptor already appends
 * committeeScope on every request.
 */
export function useAvailableStates() {
  const { activeCommitteeId } = useCommitteeScope()
  return useQuery<AvailableState[]>({
    queryKey: ['config', 'available-states', activeCommitteeId ?? null],
    queryFn: () => configApi.getAvailableStates().then((r) => r.data),
    staleTime: Infinity, // reference data; changes only when a customer's scope changes
  })
}
